/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import EditableField from '@/components/shared/EditableField'
import {Component, Prop, Vue} from 'vue-property-decorator'
import {UserVO} from '@/valueObjects/UserVO'
import {UserService} from '@/services/UserService'
import UserServiceMixin from '@/services/UserServiceMixin'

import {AnalysisService} from '@/services/AnalysisService'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'

@Component({
    components: {
        EditableField,
    },
    mixins: [UserServiceMixin, AnalysisServiceMixin],
})

export default class UserEditor extends Vue {

    @Prop()
    public user: UserVO

    private isSaving: boolean = false
    private editedUser: UserVO = this.user
    private userService: UserService // redeclared variable to avoid warnings in Webstorm

    private analysisService: AnalysisService
    private analyses: AnalysisVO[] = []

    private remove(userToDelete: UserVO) {
        this.$emit('delete', userToDelete)
    }

    private onEditionStarted(event: Event) {
        this.$emit('editionStarted', this.editedUser)
    }

    private async onValidated(event: Event) {
        if (this.editedUser.isValid() && !this.isSaving) {
            this.isSaving = true
            try {
                this.$emit('save')
                await this.userService.save(this.editedUser)
                this.$emit('saved')
            } catch (err) {
                this.$emit('error', err.errorMessage)
            }
            this.isSaving = false
        }
    }

    get isAdmin(): boolean {
        return this.editedUser.roles && this.editedUser.roles.indexOf('admin') >= 0
    }

    get isApi(): boolean {
        return this.editedUser.roles && this.editedUser.roles.indexOf('api') >= 0
    }

    set isAdmin(value: boolean) {
        this.ensureRoleListExists()

        if (value) {
            this.addRole('admin')
        } else {
            this.removeRole('admin')
        }

        if (this.editedUser.id > 0) {
            this.$emit('save')
            try {
                // do new try to save when setting admin during user creation
                this.userService.saveRoles(this.editedUser)
                this.$emit('saved')
            } catch (err) {
                this.$emit('error', err.errorMessage)
            }
        }
    }

    set isApi(value: boolean) {
        this.ensureRoleListExists()

        if (value) {
            this.addRole('api')
        } else {
            this.removeRole('api')
        }

        if (this.editedUser.id > 0) {
            this.$emit('save')
            try {
                // do new try to save when setting admin during user creation
                this.userService.saveRoles(this.editedUser)
                this.$emit('saved')
            } catch (err) {
                this.$emit('error', err.errorMessage)
            }
        }
    }

    private ensureRoleListExists() {
        if (this.editedUser.roles === undefined) {
            this.editedUser.roles = []
        }
    }

    private addRole(role: string) {
        if (this.editedUser.roles.indexOf(role) < 0) {
            this.editedUser.roles.push(role)
        }
    }

    private removeRole(role: string) {
        const index: number = this.editedUser.roles.indexOf(role)
        if (index >= 0) {
            this.editedUser.roles.splice(index, 1)
        }
    }

    private getNumberApkPost(user: UserVO): string {
    return String(user.nbApkPost)
    }

}
